// TODO: Replace with real backend API call when endpoint is available.
const AD_MOCK = {
  email: "keidsouza@deloitte.com",
  exists_in_ad: true,
  details: {
    id: "f6beaf7b-72ff-4bda-8ce4-439e163ecea3",
    createdDateTime: "2023-01-04T19:07:04Z",
    country: "United States",
    employeeType: "Contractor",
    givenName: "Keith",
    jobTitle: "External,DTTS MF CLOUD ENGIN",
    mail: "keidsouza@deloitte.com",
    mailNickname: "keidsouza",
    otherMails: [],
    userPrincipalName: "keidsouza@deloitte.com",
    userType: "Member",
  },
};

export async function fetchADUser(email) {
  // Simulate network latency
  await new Promise((resolve) => setTimeout(resolve, 400));

  // Return mock regardless of queried email so the UI can be previewed
  return { ...AD_MOCK, email };
}
